import { render, staticRenderFns } from "./BuyLedger.vue?vue&type=template&id=62c97d3f&scoped=true&"
import script from "./BuyLedger.vue?vue&type=script&lang=js&"
export * from "./BuyLedger.vue?vue&type=script&lang=js&"
import style0 from "./BuyLedger.vue?vue&type=style&index=0&id=62c97d3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c97d3f",
  null
  
)

export default component.exports